var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-pond',{ref:"pond",staticClass:"pond",attrs:{"name":"input-file","label-idle":"Drop files here...","allow-multiple":false},on:{"addfile":_vm.readFile}})}
var staticRenderFns = []

export { render, staticRenderFns }